import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-3">
          合作通道
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          {contactData.title}
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto">
          {contactData.description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
          <div className="flex items-center gap-3 bg-background-100 rounded-xl px-6 py-4">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-mail-line text-accent-600 text-lg"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-foreground-400">电子邮箱</p>
              <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-background-100 rounded-xl px-6 py-4">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-chat-3-line text-accent-600 text-lg"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-foreground-400">QQ 联系</p>
              <p className="text-sm font-medium text-foreground-800">{contactData.qq}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}